import { h, Fragment, cn, type VNode } from '../../../lib/vdom.js';
import * as I from './Icon.jsx';

export type ImageData = { src: string; caption: VNode; withoutShadow?: boolean };

export function ImageCarousel(props: { images: ImageData[] }) {
  return (
    <div className="image-carousel">
      {props.images.map((data, i) => (
        <Image data={data} index={i} />
      ))}
    </div>
  );
}

export function ImageCarouselScrollIndicator(props: { count: number }) {
  return (
    <div className="image-carousel-scroll-indicator">
      {Array.from({ length: props.count }, () => (
        <span />
      ))}
    </div>
  );
}

function Image(props: { data: ImageData; index: number }) {
  return (
    <div className="image" data-index={props.index}>
      <img src={props.data.src} className={props.data.withoutShadow ? 'without-shadow' : ''} fetchpriority="low" />
      <div className="caption">{props.data.caption}</div>
    </div>
  );
}

export function ImageCarouselScrollButtons() {
  return (
    <div className="image-carousel-scroll-buttons">
      <button className="prev">
        <I.IconChevronLeft />
      </button>
      <button className="next">
        <I.IconChevronRight />
      </button>
    </div>
  );
}

type InitImageCarouselProps = {
  parent: HTMLElement;
  onImageClick: (e: MouseEvent, index: number) => any;
};

export function initImageCarousel({ parent, onImageClick }: InitImageCarouselProps) {
  const carousel = parent.querySelector('.image-carousel') as HTMLElement;
  const prevButton = parent.querySelector('.image-carousel-scroll-buttons .prev') as HTMLButtonElement;
  const nextButton = parent.querySelector('.image-carousel-scroll-buttons .next') as HTMLButtonElement;
  const indicator = parent.querySelector('.image-carousel-scroll-indicator') as HTMLElement;

  function getScrollSize() {
    console.log(carousel.querySelector('.image')!.clientWidth);
    return carousel.querySelector('.image')!.clientWidth;
  }

  function updateIndicator() {
    const indicatorBars = indicator.children;
    const imageElems = carousel.querySelectorAll('.image');
    const carouselArea = carousel.getBoundingClientRect();

    for (const [i, imageElem] of imageElems.entries()) {
      const rect = imageElem.getBoundingClientRect();
      const visibleWidth = Math.min(rect.right, carouselArea.right) - Math.max(rect.left, carouselArea.left);
      const isVisible = visibleWidth / rect.width >= 0.9;
      if (isVisible) {
        indicatorBars[i].classList.add('cur');
      } else {
        indicatorBars[i].classList.remove('cur');
      }
    }
  }

  prevButton.onclick = function prev() {
    carousel.scrollBy({ left: -getScrollSize(), behavior: 'smooth' });
  };
  nextButton.onclick = function next() {
    carousel.scrollBy({ left: getScrollSize(), behavior: 'smooth' });
  };

  carousel.onscroll = updateIndicator;

  updateIndicator();

  // Call onImageClick.
  function carouselClicked(e: MouseEvent) {
    const target = e.target as HTMLElement;
    if (!target.matches('.image img')) return;
    const index = Number((target.closest('.image') as HTMLElement).dataset.index);
    onImageClick(e, index);
  }
  carousel.addEventListener('click', carouselClicked);
}
